module.exports = __webpack_public_path__ + "static/img/5420_phase_function_Paper_PointsHejduk_Prediction.b1e93b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5420_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VGFc
// module chunks = 0